import { createStyles, Grid, IconButton, makeStyles, Theme, Typography } from "@material-ui/core";
import { Facebook, Instagram, Phone, Pinterest, Twitter, WhatsApp, YouTube } from "@material-ui/icons";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import useLandingFunctions from "../../../../../hooks/useLandingFunctions";
import { PFXSocialComponent } from "../../../../../models/Interfaces";
import { TITLE_FONTSIZE_BASE } from "../../../../../pages/Landing";
import { selectCompany } from "../../../../../redux/slices/cleverlynkSlice";
import { selectComponentDimensions } from "../../../../../redux/slices/landingSlice";

interface ISocialMedia {
  data: PFXSocialComponent;
  id: string;
}

const SocialMedia = ({ data, id }: ISocialMedia) => {
  const { width, height } = useSelector(selectComponentDimensions);

  const {} = useLandingFunctions();
  const company = useSelector(selectCompany);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        width,
      },
      root: {
        height: height / 4,
        minHeight: 120,
        transition: "height 400ms",
        backgroundColor: data.backgroundColor ?? "#ffffff",
        position: "relative",
      },
      iconbutton: {
        backgroundColor: data.backgroundColor,
        color: data.iconColor,
      },
      title: {
        fontSize: `${data.title?.fontSizeMultiplier ?? 1 * TITLE_FONTSIZE_BASE}rem`,
        color: data.title?.color ?? "#1a1a1a",
        textAlign: (data.title?.alignment ?? "center") as any,
        fontWeight: data.title?.fontWeight as any,
        fontFamily: data.title?.fontFamily,
        "&.input": {
          height: "100%",
        },
        width: "100%",
      },
      titleDiv: {
        minHeight: `calc(${height / 8}px - 13px)`,
        width: "100%",
        borderRadius: 5,
      },
      titleInput: {
        minHeight: `calc(${height / 8}px - 13px)`,
        width: "100%",
        borderRadius: 5,
      },
    })
  );

  const classes = useStyles();

  const handleClick = (sm: string) => {
    const url = (company?.socials ?? []).find(s => s.page === sm)?.url ?? "";
    window.open(url, "_blank");
  };

  const iconsToRender = useMemo(() => {
    const icons: any[] = [];
    if (data.phoneNumber) {
      icons.push(
        <Grid item>
          <IconButton className={classes.iconbutton} onClick={() => window.open(`tel:+${(company?.phones ?? [])[0]}`)}>
            <Phone />
          </IconButton>
        </Grid>
      );
    }
    // wannabanana exception
    if (company?.id === "3uESTiXOnhZhbM6WtyieC") {
      icons.push(
        <Grid item>
          <IconButton className={classes.iconbutton} onClick={() => window.open(`https://wa.link/68rpsc`, "_blank")}>
            <WhatsApp />
          </IconButton>
        </Grid>
      );
    }
    Object.keys(data?.socialMedia ?? {}).forEach(sn => {
      if (!!data?.socialMedia![sn]) {
        switch (sn) {
          case "FACEBOOK":
            icons.push(
              <Grid item>
                <IconButton className={classes.iconbutton} onClick={() => handleClick(sn)}>
                  <Facebook />
                </IconButton>
              </Grid>
            );
            break;
          case "TWITTER":
            icons.push(
              <Grid item>
                <IconButton className={classes.iconbutton} onClick={() => handleClick(sn)}>
                  <Twitter />
                </IconButton>
              </Grid>
            );
            break;
          case "INSTAGRAM":
            icons.push(
              <Grid item>
                <IconButton className={classes.iconbutton} onClick={() => handleClick(sn)}>
                  <Instagram />
                </IconButton>
              </Grid>
            );
            break;
          case "PINTEREST":
            icons.push(
              <Grid item>
                <IconButton className={classes.iconbutton} onClick={() => handleClick(sn)}>
                  <Pinterest />
                </IconButton>
              </Grid>
            );
            break;
          case "YOUTUBE":
            icons.push(
              <Grid item>
                <IconButton className={classes.iconbutton} onClick={() => handleClick(sn)}>
                  <YouTube />
                </IconButton>
              </Grid>
            );
            break;
          default:
            break;
        }
      }
    });
    return icons;
  }, [classes.iconbutton, data.phoneNumber, data?.socialMedia]);

  return (
    <Grid container className={classes.root} id={`landing-component-${id}`} justifyContent="center" alignItems="center">
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        className={classes.container}>
        <Grid item xs={12} className={classes.titleDiv} container alignItems="center">
          <Typography className={classes.title}>{data.title?.content}</Typography>
        </Grid>
        {iconsToRender}
      </Grid>
    </Grid>
  );
};
export default SocialMedia;
